import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Consts } from '@shared/consts';
import { produce } from 'immer';
import { NavigationInfo } from "@shared/generalInterfaces";

export interface NavigationState {
	transitionsStack: NavigationInfo[];
}

export function createInitialState(): NavigationState {
	return {
		transitionsStack: [],
	};
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: Consts.NavigationStore, producerFn: produce })
export class NavigationStore extends Store<NavigationState> {
	constructor() {
		super(createInitialState());
	}

	reset(): void {
		this.update(() => createInitialState());
	}

	pushTransition(item: NavigationInfo) {
		this.update((state) => ({
			transitionsStack: [...state.transitionsStack, item], // Add item
		}));
	}

	removeTransition() {
		this.update((state) => ({
			transitionsStack: state.transitionsStack.slice(0, -1), // Remove last item
		}));
	}
}